import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'checklisFamilia',
})
export class tareasChecklistFamPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (items) {

      if (filter['incidencias']) {

        items = items.filter((familia) => {
          return (familia.sub_familias.filter((subfam) => {
            return (subfam.campos.filter((campo) => campo.observaciones)).length > 0;
          })).length > 0;
        });

      }


      if (filter['search']) {

        items = items.filter((familia) => {
          return (familia.sub_familias.filter((subfam) => {
            return (subfam.campos.filter((campo) => campo.label.toLowerCase().includes((filter['search']).toLowerCase()))).length > 0;
          })).length > 0;
        });

      }

      return items;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/tareas-checklist/tareas-checklist-fam.ts